import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@dotcom/crown-ui';
import { FooterContentProps } from '../order-drawer-types';
import styles from '../order-drawer.module.scss';

export const FooterContent = ({ onSubmit, onClose }: FooterContentProps) => {
  const { t } = useTranslation();
  return (
    <div className={styles['footer-wrapper']}>
      <Button
        testId="rotate-drawer--cancel"
        className={styles['footer-cancel-button']}
        onClick={onClose}
        variant="secondary"
      >
        {t('footerContent.cancel')}
      </Button>
      <Button
        testId="rotate-drawer--apply"
        className={styles['footer-primary-button']}
        onClick={onSubmit}
        variant="primary"
      >
        {t('footerContent.apply')}
      </Button>
    </div>
  );
};
